import { makeCell, makeRowSet } from './gridUtill';

let fields = [];
let columns = [];

// ID 컬럼 (숨김 - 데이터 식별용)
makeCell(1, [{ field: 'id', alias: 'ID', indexExclusive: true }], fields, columns);

// ID 컬럼을 숨김 처리
if (columns.length > 0) {
  columns[columns.length - 1].visible = false;
}

// 첨가제 컬럼 (돋보기 버튼 포함)
makeCell(
  1,
  [
    {
      field: 'additive',
      alias: '첨가제',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
  null, // width
  true, // editable
  {
    type: 'html',
    callback: function (grid, cell) {
      const value = cell.value || '';
      const fieldName = cell.column ? cell.column.fieldName || 'additive' : 'additive';
      const rowIndex = cell.index.itemIndex;

      // 해당 행의 ID 값 확인
      const rowData = grid.getDataSource().getJsonRow(cell.index.dataRow);
      const hasId = rowData && rowData.id != null && rowData.id !== '';

      if (hasId) {
        // ID가 있는 행은 돋보기 없이 값만 표시
        return `<div style="display: flex; align-items: center; height: 100%; padding: 0 5px;">
                  <span style="flex: 1;">${value}</span>
                </div>`;
      } else {
        // ID가 없는 행은 기존 로직대로 돋보기 표시
        if (value.trim() === '') {
          // 값이 비어있으면 돋보기 아이콘만 표시
          return `<div onclick="window.openSearchModal && window.openSearchModal('${fieldName}', ${rowIndex})" style="display: flex; align-items: center; justify-content: center; height: 100%; cursor: pointer;">
                    <i class="mdi mdi-magnify" style="font-size: 16px; color: #666;"></i>
                  </div>`;
        } else {
          // 값이 있으면 값과 돋보기 아이콘을 함께 표시
          return `<div onclick="window.openSearchModal && window.openSearchModal('${fieldName}', ${rowIndex})" style="display: flex; align-items: center; justify-content: space-between; height: 100%; padding: 0 5px; cursor: pointer;">
                    <span style="flex: 1;">${value}</span>
                    <i class="mdi mdi-magnify" style="font-size: 14px; margin-left: 5px; color: #666;"></i>
                  </div>`;
        }
      }
    },
  },
);

// 희석원료1 컬럼 (돋보기 버튼 포함)
makeCell(
  1,
  [
    {
      field: 'dilutionMaterial1',
      alias: '희석원료1',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
  null, // width
  true, // editable
  {
    type: 'html',
    callback: function (grid, cell) {
      const value = cell.value || '';
      const fieldName = cell.column ? cell.column.fieldName || 'dilutionMaterial1' : 'dilutionMaterial1';
      const rowIndex = cell.index.itemIndex;

      // 해당 행의 ID 값 확인
      const rowData = grid.getDataSource().getJsonRow(cell.index.dataRow);
      const hasId = rowData && rowData.id != null && rowData.id !== '';

      if (hasId) {
        // ID가 있는 행은 돋보기 없이 값만 표시
        return `<div style="display: flex; align-items: center; height: 100%; padding: 0 5px;">
                  <span style="flex: 1;">${value}</span>
                </div>`;
      } else {
        // ID가 없는 행은 기존 로직대로 돋보기 표시
        if (value.trim() === '') {
          // 값이 비어있으면 돋보기 아이콘만 표시
          return `<div onclick="window.openSearchModal && window.openSearchModal('${fieldName}', ${rowIndex})" style="display: flex; align-items: center; justify-content: center; height: 100%; cursor: pointer;">
                    <i class="mdi mdi-magnify" style="font-size: 16px; color: #666;"></i>
                  </div>`;
        } else {
          // 값이 있으면 값과 돋보기 아이콘을 함께 표시
          return `<div onclick="window.openSearchModal && window.openSearchModal('${fieldName}', ${rowIndex})" style="display: flex; align-items: center; justify-content: space-between; height: 100%; padding: 0 5px; cursor: pointer;">
                    <span style="flex: 1;">${value}</span>
                    <i class="mdi mdi-magnify" style="font-size: 14px; margin-left: 5px; color: #666;"></i>
                  </div>`;
        }
      }
    },
  },
);

// 희석원료2 컬럼 (돋보기 버튼 포함)
makeCell(
  1,
  [
    {
      field: 'dilutionMaterial2',
      alias: '희석원료2',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
  null, // width
  true, // editable
  {
    type: 'html',
    callback: function (grid, cell) {
      const value = cell.value || '';
      const fieldName = cell.column ? cell.column.fieldName || 'dilutionMaterial2' : 'dilutionMaterial2';
      const rowIndex = cell.index.itemIndex;

      // 해당 행의 ID 값 확인
      const rowData = grid.getDataSource().getJsonRow(cell.index.dataRow);
      const hasId = rowData && rowData.id != null && rowData.id !== '';

      if (hasId) {
        // ID가 있는 행은 돋보기 없이 값만 표시
        return `<div style="display: flex; align-items: center; height: 100%; padding: 0 5px;">
                  <span style="flex: 1;">${value}</span>
                </div>`;
      } else {
        // ID가 없는 행은 기존 로직대로 돋보기 표시
        if (value.trim() === '') {
          // 값이 비어있으면 돋보기 아이콘만 표시
          return `<div onclick="window.openSearchModal && window.openSearchModal('${fieldName}', ${rowIndex})" style="display: flex; align-items: center; justify-content: center; height: 100%; cursor: pointer;">
                    <i class="mdi mdi-magnify" style="font-size: 16px; color: #666;"></i>
                  </div>`;
        } else {
          // 값이 있으면 값과 돋보기 아이콘을 함께 표시
          return `<div onclick="window.openSearchModal && window.openSearchModal('${fieldName}', ${rowIndex})" style="display: flex; align-items: center; justify-content: space-between; height: 100%; padding: 0 5px; cursor: pointer;">
                    <span style="flex: 1;">${value}</span>
                    <i class="mdi mdi-magnify" style="font-size: 14px; margin-left: 5px; color: #666;"></i>
                  </div>`;
        }
      }
    },
  },
);

// 첨가제 비율 컬럼
makeCell(1, [{ field: 'additiveRatio', alias: '첨가제 비율', indexExclusive: true, numberFormat: '#,##0.##' }], fields, columns);

// 희석 원료비율1 컬럼
makeCell(1, [{ field: 'dilutionRatio1', alias: '희석 원료비율1', indexExclusive: true, numberFormat: '#,##0.##' }], fields, columns);

// 희석 원료비율2 컬럼
makeCell(1, [{ field: 'dilutionRatio2', alias: '희석 원료비율2', indexExclusive: true, numberFormat: '#,##0.##' }], fields, columns);

// 우선순위 컬럼
makeCell(1, [{ field: 'priority', alias: '우선순위', indexExclusive: true, numberFormat: '#,##0' }], fields, columns);

// 비고 컬럼
makeCell(1, [{ field: 'remark', alias: '비고', indexExclusive: true }], fields, columns);

// 생성일 컬럼
makeCell(1, [{ field: 'regDt', alias: '생성일', indexExclusive: true, datetimeFormat: 'yyyy-MM-dd' }], fields, columns);

// 생성자 컬럼
makeCell(1, [{ field: 'reg', alias: '생성자', indexExclusive: true }], fields, columns);

const rowSet = makeRowSet(fields);
const errorMessage = '희석 용매비 데이터가 없습니다';
const hideCheckBar = false; // 체크박스 활성화

export { fields, columns, rowSet, errorMessage, hideCheckBar };
